(ns ballot-scout-v2-frontend.resources.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::resource-urls
 (fn [db]
   (:resource-urls db)))
